/**
 * The six sections of the one-page form, in document order.
 *
 * The same ids drive the rail, the xs stepper, scroll anchors, per-section completion and the
 * "jump to the topmost offending section" behaviour behind the disabled Finalize button — so this
 * order is the page's order, not a display preference.
 */
export const BULLETIN_SECTION_IDS = [
  "setup",
  "incident",
  "entities",
  "media",
  "narrative",
  "contact",
] as const;

export type BulletinSectionId = (typeof BULLETIN_SECTION_IDS)[number];
